import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHighestRated = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_497_104",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			className: "custom-rect",
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_497_104)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.2532 11.6524L16.1587 9.15238L17.718 9.29175L14.407 12.1059L15.4103 16.319L14.1924 15.593L13.2532 11.6524ZM11.6251 6.71654L10.7614 4.718L11.4712 3.06592L13.0914 6.83509L11.6251 6.71654ZM6.33345 13.8959L9.00011 12.3126L11.6876 13.8959L10.9793 10.8959L13.2918 8.91675L10.2293 8.64592L9.00011 5.79175L7.77095 8.64592L4.70845 8.91675L7.04178 10.8959L6.33345 13.8959ZM4.68761 16.1347L5.83991 11.3061L2.01782 8.05779L7.03053 7.62196L9.00011 3.06592L10.9697 7.64279L15.9824 8.05779L12.1603 11.3061L13.3126 16.1347L9.00011 13.5738L4.68761 16.1347Z",
			fill: "currentColor"
		})
	})]
});
export default SvgHighestRated;
